import { Outlet } from 'react-router-dom'
import ScrollToTop from './ScrollToTop'
import UtilityBanner from './UtilityBanner'
import SiteHeader from './SiteHeader'
import SiteFooter from './SiteFooter'

/**
 * The marketing site's shell: utility banner, header, footer, and the
 * attribution the footer carries. The agent and supervisor workspaces are
 * a different product surface with their own chrome and their own layout,
 * so they render outside this wrapper rather than inside it.
 */
export default function PublicLayout() {
  return (
    <div className="flex min-h-dvh flex-col">
      <ScrollToTop />
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:m-2 focus:rounded focus:bg-canvas focus:px-4 focus:py-2 focus:font-semibold"
      >
        Skip to main content
      </a>
      <UtilityBanner />
      <SiteHeader />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  )
}
